import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { ShopModule } from "../../../types/shopModuleTypes";
import {
  ItemCard,
  ItemHeader,
  ItemMeta,
  ColorDot,
  MetaRow,
} from "./EmployeePageWidgets.styles";
import { useTranslation } from "react-i18next";

interface Props {
  module: ShopModule;
}

const ShopModuleItem: React.FC<Props> = ({ module }) => {
  const { t } = useTranslation();
  
  return (
    <ItemCard>
      <ItemHeader>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ColorDot />
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
            {module.type}
          </Typography>
          <Chip label={`Priority ${module.priority}`} size="small" />
        </Box>
      </ItemHeader>

      <ItemMeta>
        <MetaRow>
          <Typography variant="caption">{t("shopModulesPage.maxAmount")}</Typography>
          <Typography variant="body2">{module.maxAmount ?? "—"}</Typography>
        </MetaRow>
      </ItemMeta>
    </ItemCard>
  );
};

export default ShopModuleItem;
